/* eslint-disable */
import { DropDown } from '@synergy-marine-group/synergy-ui';
import React from 'react';

const MultiSelectFieldComponent = ({
  field, // { name, value, onChange, onBlur }
  isDisabled,
  options,
  form: { touched, errors,
    setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  const handleOnChange = (value) => {
    setFieldValue(field.name, value);
  };

  return (
    <div className={`${isDisabled ? 'dropdown-disabled' : ''} `}>
      <DropDown {...field} {...props} isDisabled={isDisabled} options={options} onChange={handleOnChange} isMulti />
      {touched[field.name] && errors[field.name] && <div className="error text-xs">{errors[field.name]}</div>}
    </div>
  );
};

export default MultiSelectFieldComponent;
